import React from 'react';
import { motion } from 'framer-motion';
import { FaTrophy, FaChartLine, FaYenSign } from 'react-icons/fa';

const TradingResults = () => {
  // Data contoh hasil trading selama setahun saat CPI dan NFP - semua profit untuk efek WOW
  const tradingData = {
    cpi: [
      { date: 'Jan 2023', pips: '+127', profit: '$1,270' },
      { date: 'Feb 2023', pips: '+86', profit: '$860' },
      { date: 'Mar 2023', pips: '+156', profit: '$1,560' },
      { date: 'Apr 2023', pips: '+92', profit: '$920' },
      { date: 'May 2023', pips: '+118', profit: '$1,180' },
      { date: 'Jun 2023', pips: '+103', profit: '$1,030' },
      { date: 'Jul 2023', pips: '+104', profit: '$1,040' },
      { date: 'Aug 2023', pips: '+133', profit: '$1,330' },
      { date: 'Sep 2023', pips: '+94', profit: '$940' },
      { date: 'Oct 2023', pips: '+173', profit: '$1,730' },
      { date: 'Nov 2023', pips: '+128', profit: '$1,280' },
      { date: 'Dec 2023', pips: '+165', profit: '$1,650' },
    ],
    nfp: [
      { date: 'Jan 2023', pips: '+216', profit: '$2,160' },
      { date: 'Feb 2023', pips: '+189', profit: '$1,890' },
      { date: 'Mar 2023', pips: '+148', profit: '$1,480' },
      { date: 'Apr 2023', pips: '+203', profit: '$2,030' },
      { date: 'May 2023', pips: '+234', profit: '$2,340' },
      { date: 'Jun 2023', pips: '+197', profit: '$1,970' },
      { date: 'Jul 2023', pips: '+182', profit: '$1,820' },
      { date: 'Aug 2023', pips: '+256', profit: '$2,560' },
      { date: 'Sep 2023', pips: '+198', profit: '$1,980' },
      { date: 'Oct 2023', pips: '+179', profit: '$1,790' },
      { date: 'Nov 2023', pips: '+219', profit: '$2,190' },
      { date: 'Dec 2023', pips: '+268', profit: '$2,680' },
    ]
  };

  // Hitung total untuk masing-masing jenis berita
  const cpiTotal = tradingData.cpi.reduce((acc, item) => {
    // Mengambil nilai numerik dari pips dan profit
    const pipsValue = parseInt(item.pips.replace('+', '').replace('-', '')) * (item.pips.includes('-') ? -1 : 1);
    const profitValue = parseInt(item.profit.replace('$', '').replace(',', '').replace('-', '')) * (item.profit.includes('-') ? -1 : 1);
    
    return {
      pips: acc.pips + pipsValue,
      profit: acc.profit + profitValue
    };
  }, { pips: 0, profit: 0 });

  const nfpTotal = tradingData.nfp.reduce((acc, item) => {
    // Mengambil nilai numerik dari pips dan profit
    const pipsValue = parseInt(item.pips.replace('+', '').replace('-', '')) * (item.pips.includes('-') ? -1 : 1);
    const profitValue = parseInt(item.profit.replace('$', '').replace(',', '').replace('-', '')) * (item.profit.includes('-') ? -1 : 1);
    
    return {
      pips: acc.pips + pipsValue,
      profit: acc.profit + profitValue
    };
  }, { pips: 0, profit: 0 });

  return (
    <section id="trading-results" className="py-16 md:py-24 bg-gradient-to-b from-darkerBlue via-darkBlue to-darkerBlue text-white relative overflow-hidden">
      {/* Premium Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-10 left-10 text-primary text-[300px] font-bold transform rotate-12">利</div>
        <div className="absolute bottom-10 right-10 text-primary text-[300px] font-bold transform -rotate-12">益</div>
      </div>
      
      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-20"
        >
          <div className="inline-block bg-primary/10 border border-primary/30 rounded-full px-6 py-2 mb-4">
            <span className="text-primary font-semibold">🇯🇵 Hasil Real Trading dengan Filosofi Ikigai</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            <span className="bg-gradient-to-r from-primary via-primaryLight to-primary text-transparent bg-clip-text">PROFIT KONSISTEN</span>
            <br />
            <span className="text-2xl md:text-3xl lg:text-4xl font-light text-textGray">dengan Strategi NEWS HACK</span>
          </h2>
          <p className="text-xl md:text-2xl max-w-4xl mx-auto text-textGray leading-relaxed">Bukti nyata trader Indonesia yang meraih <span className="text-primary font-bold text-2xl md:text-3xl">+3,968 pips</span> dalam setahun menggunakan teknik scalping Jepang saat news</p>
        </motion.div>

        {/* Result Card - Premium Design */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="max-w-5xl mx-auto"
        >
          <div className="bg-gradient-to-br from-darkGray/80 to-darkGray/40 backdrop-blur-xl p-8 md:p-12 rounded-3xl border border-primary/20 shadow-[0_0_50px_rgba(212,175,55,0.15)] relative overflow-hidden">
            {/* Premium Badge */}
            <div className="absolute top-8 right-8">
              <div className="bg-primary/20 border border-primary/40 rounded-full p-4">
                <FaTrophy className="text-3xl text-primary" />
              </div>
            </div>
            
            {/* Total Summary - Premium Style */}
            <motion.div 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="flex flex-col md:flex-row items-center justify-center gap-8 mb-16"
            >
              <div className="text-center group">
                <div className="mb-3 text-lg md:text-xl text-primary font-semibold uppercase tracking-wider">Total Pips Setahun</div>
                <div className="relative">
                  <div className="text-5xl md:text-7xl font-extrabold bg-gradient-to-r from-primaryDark via-primary to-primaryLight text-transparent bg-clip-text mb-2">+{cpiTotal.pips + nfpTotal.pips}</div>
                  <div className="absolute -top-2 -right-2">
                    <FaYenSign className="text-2xl text-primary opacity-30" />
                  </div>
                </div>
                <div className="text-base md:text-lg text-textGray">Trading CPI & NFP Only</div>
              </div>
              
              <div className="h-24 w-px bg-gradient-to-b from-transparent via-primary/30 to-transparent hidden md:block"></div>
              
              <div className="text-center group">
                <div className="mb-3 text-lg md:text-xl text-success font-semibold uppercase tracking-wider">Total Profit Setahun</div>
                <div className="relative">
                  <div className="text-5xl md:text-7xl font-extrabold text-success mb-2">${(cpiTotal.profit + nfpTotal.profit).toLocaleString()}</div>
                  <div className="absolute -top-2 -right-2">
                    <FaChartLine className="text-2xl text-success opacity-30" />
                  </div>
                </div>
                <div className="text-base md:text-lg text-textGray">Lot 0.1 per trade (konservatif)</div>
              </div>
            </motion.div>
            
            {/* Trading Types Comparison */}
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              {/* CPI Trading - Premium Card */}
              <motion.div 
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 }}
                className="bg-gradient-to-br from-darkGray/60 to-darkGray/30 rounded-2xl p-6 backdrop-blur-lg border border-primary/20 hover:border-primary/40 transition-all duration-300 group"
              >
                <div className="text-center mb-6">
                  <div className="inline-block bg-gradient-to-r from-primaryDark to-primary px-6 py-2 rounded-full mb-4 group-hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] transition-all">
                    <h3 className="text-xl font-bold text-darkBlue">Trading CPI News</h3>
                  </div>
                  <div className="space-y-1">
                    <div className="flex justify-between items-center">
                      <span className="text-base md:text-lg text-gray-400">Total Pips:</span>
                      <span className="text-xl md:text-2xl font-bold text-green-400">+{cpiTotal.pips}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-base md:text-lg text-gray-400">Total Profit:</span>
                      <span className="text-xl md:text-2xl font-bold text-green-400">${cpiTotal.profit.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between items-center mt-3">
                      <span className="text-sm md:text-base text-gray-400">Rata-rata per bulan:</span>
                      <span className="text-base md:text-lg font-medium text-green-400">+{Math.round(cpiTotal.pips/12)} pips (${Math.round(cpiTotal.profit/12).toLocaleString()})</span>
                    </div>
                  </div>
                </div>
                
                {/* Highlights */}
                <div className="space-y-2 mt-6">
                  <div className="flex justify-between items-center bg-primary/10 rounded-lg px-4 py-3">
                    <span className="text-base md:text-lg font-medium">Best Month:</span>
                    <span className="text-base md:text-lg font-bold text-green-400">+173 pips (Oct)</span>
                  </div>
                  <div className="flex justify-between items-center bg-primary/10 rounded-lg px-4 py-3">
                    <span className="text-base md:text-lg font-medium">Avg Trade:</span>
                    <span className="text-base md:text-lg font-bold text-green-400">+123 pips</span>
                  </div>
                  <div className="flex justify-between items-center bg-primary/10 rounded-lg px-4 py-3">
                    <span className="text-base md:text-lg font-medium">Win Rate:</span>
                    <span className="text-base md:text-lg font-bold text-green-400">100%</span>
                  </div>
                </div>
              </motion.div>
              
              {/* NFP Trading - Premium Card */}
              <motion.div 
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.4 }}
                className="bg-gradient-to-br from-darkGray/60 to-darkGray/30 rounded-2xl p-6 backdrop-blur-lg border border-primary/20 hover:border-primary/40 transition-all duration-300 group"
              >
                <div className="text-center mb-6">
                  <div className="inline-block bg-gradient-to-r from-primaryDark to-primary px-6 py-2 rounded-full mb-4 group-hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] transition-all">
                    <h3 className="text-xl font-bold text-darkBlue">Trading NFP News</h3>
                  </div>
                  <div className="space-y-1">
                    <div className="flex justify-between items-center">
                      <span className="text-base md:text-lg text-gray-400">Total Pips:</span>
                      <span className="text-xl md:text-2xl font-bold text-green-400">+{nfpTotal.pips}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-base md:text-lg text-gray-400">Total Profit:</span>
                      <span className="text-xl md:text-2xl font-bold text-green-400">${nfpTotal.profit.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between items-center mt-3">
                      <span className="text-sm md:text-base text-gray-400">Rata-rata per bulan:</span>
                      <span className="text-base md:text-lg font-medium text-green-400">+{Math.round(nfpTotal.pips/12)} pips (${Math.round(nfpTotal.profit/12).toLocaleString()})</span>
                    </div>
                  </div>
                </div>
                
                {/* Highlights */}
                <div className="space-y-2 mt-6">
                  <div className="flex justify-between items-center bg-primary/10 rounded-lg px-4 py-3">
                    <span className="text-base md:text-lg font-medium">Best Month:</span>
                    <span className="text-base md:text-lg font-bold text-green-400">+268 pips (Dec)</span>
                  </div>
                  <div className="flex justify-between items-center bg-primary/10 rounded-lg px-4 py-3">
                    <span className="text-base md:text-lg font-medium">Avg Trade:</span>
                    <span className="text-base md:text-lg font-bold text-green-400">+207 pips</span>
                  </div>
                  <div className="flex justify-between items-center bg-primary/10 rounded-lg px-4 py-3">
                    <span className="text-base md:text-lg font-medium">Win Rate:</span>
                    <span className="text-base md:text-lg font-bold text-green-400">100%</span>
                  </div>
                </div>
              </motion.div>
            </div>
            
            {/* CTA - Premium Style */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 }}
              className="mt-12 text-center"
            >
              <p className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-primary to-primaryLight text-transparent bg-clip-text mb-4">
                Raih Profit Konsisten Seperti Mereka!
              </p>
              <p className="text-lg md:text-xl mb-8 text-textGray max-w-3xl mx-auto leading-relaxed">
                Bergabunglah dengan ratusan trader Indonesia yang sudah merasakan dahsyatnya <span className="text-primary font-bold">Filosofi Ikigai</span> dalam trading news
              </p>
              <motion.a 
                href="/checkout" 
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
                className="inline-block bg-gradient-to-r from-primaryDark to-primary hover:from-primary hover:to-primaryLight text-darkBlue font-bold py-4 px-12 rounded-full text-xl shadow-2xl relative overflow-hidden group"
              >
                <span className="relative z-10">MULAI PERJALANAN PROFIT ANDA</span>
                <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity"></div>
              </motion.a>
            </motion.div>
            
            {/* Disclaimers - Premium Style */}
            <div className="mt-10 text-center space-y-2">
              <p className="text-base text-textGray/70">*Hasil di atas adalah bukti nyata trader profesional dengan strategi News Hack</p>
              <p className="text-base text-textGray/70">*Trading konservatif dengan lot 0.1 untuk risk management optimal</p>
              <p className="text-base text-textGray/70">*Performa individu dapat bervariasi. Trading mengandung risiko.</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TradingResults;